import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// Routes
import Home from './routes/Home';
import Login from './routes/Login';
import Signup from './routes/Signup';
import MyAccount from './routes/MyAccount';
import Products from './routes/Products';
import Category from './routes/Category';
import Product from './routes/Product';
import Wishlist from './routes/Wishlist';
import Cart from './routes/Cart';
import Checkout from './routes/Checkout';
import Order from './routes/Order';
import About from './routes/About';
import Contact from './routes/Contact';
import Blogs from './routes/Blogs';
import Blog from './routes/Blog';
import Privacy from './routes/Privacy';
import OrderTracking from './routes/OrderTracking';
import OrderTrackingView from './routes/OrderTrackingView';
import Help from './routes/Help';
// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer'; 
import QuickView from './components/QuickView';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [user, setUser] = useState(null);
  const [currency, setCurrency] = useState('$');
  const [showQuickView, setShowQuickView] = useState(false);

  const [categories, setCategories] = useState([
    {
      name: "Men",
      subCategories: [
        {
          name: 'Shirt',
          link: '/category/men/shirt'
        },
        {
          name: 'Jeans',
          link: '/category/men/jeans'
        },
        {
          name: 'Sun Glass',
          link: '/category/men/sun-glass'
        },
        {
          name: 'T-Shirt',
          link: '/category/men/t-shirt'
        },
        {
          name: 'Shoes',
          link: '/category/men/shoes'
        }
      ]
    },
    {
      name: "Women",
      subCategories: [
        {
          name: 'Sharees',
          link: '/category/women/shirt'
        },
        {
          name: 'Three Piece',
          link: '/category/women/three-piece'
        },
        {
          name: 'Sun Glass',
          link: '/category/women/sun-glass'
        },
        {
          name: 'Dresses',
          link: '/category/women/dresses'
        },
        {
          name: 'Shoes',
          link: '/category/women/shoes'
        }
      ]
    },
    {
      name: "Electronics",
      subCategories: [
        {
          name: 'Smartphones & Accessories',
          link: '/category/electronics/smartphones'
        },
        {
          name: 'Home Appliances',
          link: '/category/electronics/home-appliances'
        },
        {
          name: 'Computers',
          link: '/category/electronics/computers'
        },
        {
          name: 'Cameras',
          link: '/category/electronics/cameras'
        },
        {
          name: 'Networking',
          link: '/category/electronics/networking'
        }
      ]
    },
    {
      name: "Books",
      subCategories: [
        {
          name: 'Islamic Books',
          link: '/category/books/islamic-books'
        },
        {
          name: 'Fiction',
          link: '/category/books/fiction'
        },
        {
          name: 'Non-Fiction',
          link: '/category/books/non-fiction'
        },
        {
          name: 'Politics',
          link: '/category/books/politics'
        },
        {
          name: 'Novels',
          link: '/category/books/novels'
        }
      ]
    }
  ]);

  useEffect(() => {
    window.mobileAndTabletCheck = function() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };
  }, [])

  useEffect(() => {
    if(!window.mobileAndTabletCheck){
      if(showQuickView){
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '17px';
        document.querySelector('.main_nav').style.paddingRight = '17px';
      }
      else{
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = '0px';
        document.querySelector('.main_nav').style.paddingRight = '0px';
      }
    }
    else{
      if(showQuickView){
        document.body.style.overflow = 'hidden';
      }
      else{
        document.body.style.overflow = 'auto';
      }
    }
  }, [showQuickView])

  return (
    <div className='App'>

      {
        showQuickView?
        <QuickView setShowQuickView={setShowQuickView} />
        
        : ''
      }

      <Router>
        <>
          <Navbar categories={categories} />
          <div className='page_body'>
            <ScrollToTop />
            <Routes>
              <Route path='/' exact element={<Home setShowQuickView={setShowQuickView} categories={categories} />} />
              <Route path='/login' element={<Login />} />
              <Route path='/signup' element={<Signup />} />
              <Route path='/my-account' element={<MyAccount page='dashboard'/>} />
              <Route path='/my-account/dashboard' element={<MyAccount page='dashboard' />} />
              <Route path='/my-account/orders' element={<MyAccount page='orders' />} />
              <Route path='/my-account/addresses' element={<MyAccount page='addresses' />} />
              <Route path='/my-account/edit-shipping-address' element={<MyAccount page='edit_shipping_address' />} />
              <Route path='/my-account/edit-billing-address' element={<MyAccount page='edit_billing_address' />} />
              <Route path='/my-account/addresses' element={<MyAccount page='addresses' />} />
              <Route path='/my-account/account-details' element={<MyAccount page='account-details' />} />
              <Route path='/products' element={<Products setShowQuickView={setShowQuickView} />} />
              <Route path='/categories' element={<Products setShowQuickView={setShowQuickView} />} />
              <Route path='/category/:category/:subCategory' element={<Category setShowQuickView={setShowQuickView} />} />
              <Route path='/product' element={<Product setShowQuickView={setShowQuickView} />} />
              <Route path='/product' element={<Product setShowQuickView={setShowQuickView} />}>
                <Route path=':id' element={<Product setShowQuickView={setShowQuickView} />} />
              </Route>
              <Route path='/wishlist' element={<Wishlist />} />
              <Route path='/cart' element={<Cart />} />
              <Route path='/checkout' element={<Checkout />} />
              <Route path='/order/:id' element={<Order />} />
              <Route path='/order-tracking' element={<OrderTracking />} />
              <Route path='/order-tracking/:id' element={<OrderTrackingView />} />
              <Route path='/about' element={<About />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/blogs' element={<Blogs />} />
              <Route path='/blog/:id' element={<Blog />} />
              <Route path='/privacy' element={<Privacy />} />
              <Route path='/help' element={<Help />} />
            </Routes>
            {/* <Home currency={currency} />
            <Products currency={currency} />
            <Product currency={currency} />
            <Cart currency={currency} />
            <Wishlist currency={currency} />
            <Checkout currency={currency} />
            <MyAccount page='dashboard' />
            <MyAccount page='orders' currency={currency} />
            <MyAccount page='addresses' />
            <MyAccount page='account-details' /> */}
          </div>
          <Footer />
        </>
      </Router>
    </div>
  );
}

export default App;
